/*
  HAPPE BOX V3 - Storefront Event Bus Module (theme-events.js)
  Consolidates component messaging without direct DOM binds.
*/

class HappeEventBus {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
  }

  emit(event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => {
      try {
        callback(data);
      } catch (e) {
        console.error(`[Happe Event Bus] Error in subscriber to "${event}":`, e);
      }
    });
  }
}

window.HappeEventBusClass = HappeEventBus;
